const year = new Date().getUTCFullYear()

export const Footer = () => {
    return (
        <div className="_bgcl-primary-main _mgt-at _mnh-64px _mnh-128px-md _mnh-256px-lg">
            {/* <hr className="rei-hr" /> */}
            {/* <div className="_dp-f _fdrt-cl _fdrt-r-md _jtfct-spbtw _alit-ct _pdv-16px _pdv-12px-md _pdh-24px">
                <img
                    src="./images/rei-finance-white.svg"
                    className="_w-50pct _w-us-md _mxw-256px"
                />
                <SocialList className="_mgt-4px _mgbt-8px" />
                <div>© {year} REI Chain. All Rights Reserved.</div>
            </div> */}
        </div>
    )
}

export default Footer
